import * as React from 'react';
import moment from 'moment-timezone';

import './TimeCard.css';
import { TIMEZONE } from '../../../utils/constants';

interface Props {
    date?: Date;
}

export class TimeCard extends React.PureComponent<Props> {
    static defaultProps = {
        date: new Date()
    };

    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <div className="timeBox" data-testid="time-card">
                <h3 className="text__center">
                    <strong>{moment(this.props.date).tz(TIMEZONE).format('h:mm A')}</strong>
                </h3>
            </div>
        );
    }
}